import { render, staticRenderFns } from "./VRemoveTeammate.vue?vue&type=template&id=233e2d94&scoped=true&lang=pug"
import script from "./VRemoveTeammate.vue?vue&type=script&lang=ts"
export * from "./VRemoveTeammate.vue?vue&type=script&lang=ts"
import style0 from "./VRemoveTeammate.vue?vue&type=style&index=0&id=233e2d94&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e2d94",
  null
  
)

/* custom blocks */
import block0 from "./RemoveTeammate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FTeammates%2FRemoveTeammate%2FVRemoveTeammate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports